<template>
  <div :class="['emd-modal', open ? '_active' : '', modalModify]">
    <div :class="['emd-modal__content', contentModify]">
      <div class="emd-container _highlight_header" :class="{'_footer_end': footerButtonsOnRight}">
        <div class="emd-container__header" v-if="hasHeader">
          <slot name="header"></slot>
          <button @click="close" class="emd-btn _type_link">
            <i class="uil uil-times emd-text _size_subpage"></i>
          </button>
        </div>
        <div class="emd-container__content">
          <slot name="content"></slot>
        </div>
        <div class="emd-container__footer" v-if="hasFooter">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmdModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    hasHeader: {
      type: Boolean,
      default: false
    },
    hasFooter: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    footerButtonsOnRight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    contentModify () {
      const classes = []
      if (this.scrollable) classes.push('_scrollable')
      return classes
    },
    modalModify () {
      const classes = []
      if (this.size) classes.push(`_size_${this.size}`)
      return classes
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
